import React, { FC, ReactNode } from 'react';
import { Breadcrumb, Col, Layout, Row } from 'antd';
import { useParams } from 'react-router-dom';
import { BreadcrumbItemType, BreadcrumbSeparatorType } from 'antd/es/breadcrumb/Breadcrumb';
import { Control } from 'common/svg';
import { ESidebarMenuKey, ESidebarMenuLabel, sidebarMenuIcons } from 'common/models/commonModel';
import { dateFormatter } from 'common/helpers/date.helper';

const { Header } = Layout;

type ItemType = Partial<BreadcrumbItemType & BreadcrumbSeparatorType & { isLast: boolean }>;

interface IComponentProps {
  title: ReactNode;
  extra?: ReactNode;
}

export const PageHeader: FC<IComponentProps> = ({ title, extra }) => {
  const { segments } = useParams<{ segments: string | undefined }>();
  const items = segments
    ?.split('/')
    .filter(Boolean)
    .map((item, index, array) => {
      return {
        title: item,
        isLast: index === array.length - 1,
      };
    });

  return (
    <Header className="page-header">
      <Row align="middle" justify="space-between" className="width-full page-header__row">
        <Col>
          <Breadcrumb
            className="page-header__breadcrumb"
            items={items}
            separator={<Control />}
            itemRender={(route: ItemType) => {
              if (!route.isLast) {
                return ESidebarMenuLabel[route.title as ESidebarMenuKey];
              }

              return (
                <div className="page-header__breadcrumb-item">
                  {sidebarMenuIcons[route.title as string]}
                  {ESidebarMenuLabel[route.title as ESidebarMenuKey]}
                </div>
              );
            }}
          />
        </Col>
        <Col>
          {/* TODO */}
          <span className="ff-regular fs-xxxs color-gray-1">{`Last updated ${dateFormatter(
            new Date().toISOString(),
            'MM/DD/YY HH:mm'
          )}`}</span>
        </Col>
      </Row>
      <Row gutter={[0, 8]} align="middle" justify="space-between" className="page-header__row">
        <Col className="ff-regular fs-lg">{title}</Col>
        <Col>{extra}</Col>
      </Row>
    </Header>
  );
};
